import './LogoSidebar.css';

export const InvLogoSidebar = (props) => {
    return (
        <div className={ props.faq ? "LogoSideBar-faq" : "LogoSideBar"}>
            <div className="sidebarColorInvision"/>
            <div className="invision"/>
        </div>
    )
}